<template>
  <div class="switcher-container">
    <v-icon v-if="dayNightSwitch" size="20">mdi-white-balance-sunny</v-icon>
    <v-switch
      v-model="dayNightSwitch"
      class="switch"
      outlined
      :disabled="freeze"
      inset
      dark
      @click="$emit('switch')"
    ></v-switch>
    <v-icon v-if="!dayNightSwitch" size="20">mdi-moon-waxing-crescent</v-icon>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dayNightSwitch: true,
    };
  },
  props: {
    isDay: Boolean,
    freeze: Boolean,
  },
};
</script>

<style scoped>
.switch {
  position: absolute;
  right: 0 !important;
  top: 20px !important;
}
.switcher-container {
  width: 50px;
  height: 55px;
  display: flex;
}
.mdi-white-balance-sunny {
  position: absolute;
  right: 37px;
  top: 22px;
}
.mdi-moon-waxing-crescent {
  transform: rotateZ(45deg);
  position: absolute;
  right: 18px;
  top: 22px;
}
</style>